import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { logout, setRefreshToken } from 'features/auth/authSlice';

const backendURL = process.env.REACT_APP_BASE_URL_DEV;

const baseQuery = fetchBaseQuery({
  baseUrl: backendURL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const token = (getState() as RootState).auth.accessToken?.token;
    if (token && endpoint !== 'authExchange') {
      headers.set('authorization', `Bearer ${token}`);
      return headers;
    }
    return headers;
  },
});

const baseQueryRefresh = fetchBaseQuery({
  baseUrl: backendURL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.refreshToken?.token || localStorage.getItem('refreshToken');
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      return headers;
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    const refreshResult = await baseQueryRefresh({ url: 'emailauth/refresh', method: 'POST' }, api, extraOptions);
    if (refreshResult.data) {
      api.dispatch(setRefreshToken({ ...refreshResult.data }));
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
    }
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['documents', 'documenttemplates', 'documenttemplate', 'document', 'file', 'users'],
  endpoints: () => ({}),
});

